import React from 'react';

import {  Redirect } from "react-router-dom";
import CompVendaProduto from '../../components/DashBoard/compvendaproduto';


export default function VendasProduto() {
      const isLogged = !!localStorage.getItem('lukos-token');

      if (isLogged === false) {
        return(<Redirect to="/login" />)
      }
      else
      {  return (        
                    <div>
                      <CompVendaProduto />
                  </div>
                  );
  };
}
